import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AnnouncementService } from '../../services/announcement.service';

@Component({
  selector: 'app-announcement-compose',
  templateUrl: './announcement-compose.component.html',
  styleUrls: ['./announcement-compose.component.css']
})
export class AnnouncementComposeComponent {
  title = '';
  message = '';
  sending = false;
  // Target audience: 'web' = employees on the web app, 'mobile' = collectors on the mobile app.
  audience: 'web' | 'mobile' = 'web';

  constructor(
    private dialogRef: MatDialogRef<AnnouncementComposeComponent>,
    private announcementService: AnnouncementService,
    private snackBar: MatSnackBar
  ) {}

  get canSend(): boolean {
    return !!this.message && this.message.trim().length > 0 && !this.sending;
  }

  send(): void {
    if (!this.canSend) { return; }
    this.sending = true;
    const createdBy = localStorage.getItem('loggedInUserName') || localStorage.getItem('loggedInUser') || 'admin';
    this.announcementService.create(this.title.trim(), this.message.trim(), createdBy, this.audience).subscribe({
      next: () => {
        this.sending = false;
        const target = this.audience === 'mobile' ? 'mobile app users' : 'web users';
        this.snackBar.open(`Announcement sent to ${target}`, 'Close', { duration: 3000 });
        this.dialogRef.close(true);
      },
      error: () => {
        this.sending = false;
        this.snackBar.open('Failed to send announcement', 'Close', { duration: 3000 });
      }
    });
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
